// extracted by mini-css-extract-plugin
export default {"tooltipContainer":"tooltip_tooltipContainer__JcVUO","tooltipBox":"tooltip_tooltipBox__Ldf9g","tooltipArrow":"tooltip_tooltipArrow__AZYPc"};